import { render, staticRenderFns } from "./PageEditorListInput.vue?vue&type=template&id=789f77f5"
import script from "./PageEditorListInput.vue?vue&type=script&lang=js"
export * from "./PageEditorListInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports